<template>
  <div class="profile" @scroll="handleScroll()">
    <img class="profile__bg" :src="images.bg" />
    <div class="profile__container">
      <div
        class="profile__container__header"
        :style="`background-image:url(${images.title})`"
      >
        <img
          v-if="can_goback"
          class="back"
          :src="images.back"
          @click="goBack()"
        />
      </div>
      <div
        class="profile__container__userinfo"
        :style="`background-image:url(${images.icon3})`"
      >
        <!-- <img class="userinfo__bg" :src="images.avatar_bg" /> -->
        <!-- <img class="userinfo__icon1" :src="images.icon1" />
        <img class="userinfo__icon2" :src="images.icon2" />-->
        <div class="userinfo__wrapper">
          <input
            type="file"
            ref="uploadPhoto"
            accept="image/*"
            @change="uploadPhoto_change"
            style="display:none;"
          />
          <div class="userinfo__avatar" @click="updateAvatar()">
            <img
              class="userinfo__avatar__bg"
              v-if="message && message.segment && message.segment.image"
              :src="getImg(message.segment.image)"
            />
            <img
              class="userinfo__avatar__img"
              v-if="otherInfo && otherInfo.avatar"
              :src="getImg(otherInfo.avatar)"
            />
          </div>
          <!-- <div class="userinfo__avatar" @click="updateAvatar()" :style="{ backgroundImage: `url(${getImg(otherInfo.avatar)})` }"></div> -->
          <div class="userinfo__name">
            {{ otherInfo.name }}
            <span
              class="userinfo__segment"
              v-if="message && message.segment && message.segment.name"
              >[{{ message && message.segment && message.segment.name }}]</span
            >
          </div>
          <div
            v-if="otherInfo.user !== ownerInfo.owner && message"
            :class="
              `userinfo_follow ${message.is_follow ? 'unselect' : 'select'}`
            "
            @click="followEvent(message.is_follow)"
          >
            {{ message.is_follow ? "取消关注" : "+ 关注" }}
          </div>
          <div class="userinfo__intro">
            作品 {{ message && message.work_count ? message.work_count : 0 }}
            <span class="userinfo__intro__line"></span>
            动态 {{ message && message.post_count ? message.post_count : 0 }}
            <span class="userinfo__intro__line"></span>
            声望
            {{
              message && message.segment && message.segment.prestige_number
                ? message.segment.prestige_number
                : 0
            }}
            <span class="userinfo__intro__line"></span>
            <span class="follow" @click="goMyFollower('follow')"
              >关注
              {{
                message && message.follow_count ? message.follow_count : 0
              }}</span
            >
            <span class="userinfo__intro__line"></span>
            <span class="fan" @click="goMyFollower('fan')"
              >粉丝
              {{ message && message.fan_count ? message.fan_count : 0 }}</span
            >
          </div>
        </div>
      </div>

      <div class="profile__container__content" ref="contents">
        <!-- 左边侧边栏 -->
        <div class="wrap-left">
          <div class="contentView__header">
            <div class="row">
              <p class="circle"></p>
              <span
                :class="
                  `contentView__header__btn ${tab === 'post' ? 'select' : ''}`
                "
                @click="tabClickEvent('post')"
                >我的动态</span
              >
            </div>
            <div class="row">
              <p class="circle"></p>
              <span
                :class="
                  `contentView__header__btn ${tab === 'work' ? 'select' : ''}`
                "
                @click="tabClickEvent('work')"
                >我的作品</span
              >
            </div>
            <div class="row">
              <p class="circle"></p>
              <span
                :class="
                  `contentView__header__btn ${tab === 'buy' ? 'select' : ''}`
                "
                @click="tabClickEvent('buy')"
                >我购买的</span
              >
            </div>
            <div
              class="row"
              v-if="ownerInfo.owner === otherInfo.user && ownerInfo.company"
            >
              <p class="circle"></p>
              <span
                :class="
                  `contentView__header__btn ${tab === 'detail' ? 'select' : ''}`
                "
                @click="tabClickEvent('detail')"
                >我的公司</span
              >
            </div>
            <div class="row">
              <p class="circle"></p>
              <span
                :class="
                  `contentView__header__btn ${
                    tab === 'certificate' ? 'select' : ''
                  }`
                "
                @click="tabClickEvent('certificate')"
                >我的证书</span
              >
            </div>
            <div class="row" v-if="ownerInfo.owner === otherInfo.user">
              <p class="circle"></p>
              <span
                :class="
                  `contentView__header__btn ${tab === 'myInfo' ? 'select' : ''}`
                "
                @click="tabClickEvent('myInfo')"
                >我的信息</span
              >
            </div>
            <div class="row" v-if="ownerInfo.owner === otherInfo.user" v-show="myMedalsCount != 0">
              <p class="circle"></p>
              <span
                :class="
                  `contentView__header__btn ${
                    tab === 'medal' ? 'select' : ''
                  }`
                "
                @click="tabClickEvent('medal')"
                >我的勋章</span
              >
            </div>
          </div>
        </div>
        <!-- 右边侧边栏 -->
        <div class="wrap-right">
          <div v-if="tab === 'post'" style="padding-top: calc(1.5rem - 10px);">
            <PostList from="profile" :owner-info="ownerInfo" />
          </div>
          <WorkList
            v-else-if="tab === 'work'"
            data-type="my"
            :typeArr="typeArr"
            :number="number"
          />
          <MyBuyWorkList v-else-if="tab === 'buy'" />
          <DetailCompanyView
            v-else-if="
              tab === 'detail' &&
                ownerInfo.owner === otherInfo.user &&
                ownerInfo.company
            "
            :pk="ownerInfo.company.pk"
          />
          <Certificate v-else-if="tab === 'certificate'" />
          <MyInfo
            v-else-if="tab === 'myInfo' && ownerInfo.owner === otherInfo.user"
            :owner="ownerInfo"
          />
          <MyMedal
            v-else-if="tab === 'medal' && ownerInfo.owner === otherInfo.user " v-show="myMedalsCount != 0" :myMedalsList=myMedalsList
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import PostList from "./PostList.vue";
import WorkList from "./WorkList.vue";
import MyBuyWorkList from "./MyBuyWorkList.vue";
import DetailCompanyView from "./DetailCompanyView.vue";
import Certificate from "./Certificate.vue";
import MyInfo from "./MyInfo.vue";
import MyMedal from "./MyMedal.vue";
import { types as LoginTypes } from "@/store/modules/login";
import { types as CommunityTypes } from "@/store/modules/community";
import { types as ActivityTypes } from "@/store/modules/activity.js";

import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

import {
  BG,
  IMG_PROFILE__TITLE,
  IMG_PROFILE__USER_BG,
  IMG_PROFILE_ICON_1,
  IMG_PROFILE_ICON_2,
  IMG_PROFILE_ICON_3,
  IMG_COMPANY_ICON,
  IMG_BACK
} from "../assets";
import { Utils, UPLOAD_SINGLE_IMAGE } from "../utils";

export default {
  name: "profile",
  components: {
    PostList,
    WorkList,
    MyBuyWorkList,
    DetailCompanyView,
    Certificate,
    MyInfo,
    MyMedal,
  },
  data() {
    return {
      images: {
        title: IMG_PROFILE__TITLE,
        bg: BG,
        avatar_bg: IMG_PROFILE__USER_BG,
        icon1: IMG_PROFILE_ICON_1,
        icon2: IMG_PROFILE_ICON_2,
        icon3: IMG_PROFILE_ICON_3,
        back: IMG_BACK,
        company_icon: IMG_COMPANY_ICON
      },
      can_goback: window.history.length > 1 ? true : false,
      tab: "post",
      number: "", //活动number，从活动页面跳过来，选择作品使用
      typeArr: null //跟活动相关
    };
  },
  computed: {
    ...mapState({
      ownerInfo: state => state.login.userInfo,
      otherInfo: state => state.login.otherInfo,
      message: state => state.login.message,
      currentActivity: state => state.activity.currentActivity,
      myMedalsCount: state => state.community.my_medals_count,
      myMedalsList: state => state.community.my_medals_list,
    })
  },

  methods: {
    ...mapMutations({
      load_otherInfo: LoginTypes.LOAD_OTHERINFO
    }),
    ...mapActions({
      dependLoginStatus: LoginTypes.LOAD_LOGIN_STATUS,
      fetchOwnInfo: LoginTypes.FETCH_USERINFO,
      fetchOtherInfo: LoginTypes.FETCH_OTHERINFO,
      fetchUnreadMessage: LoginTypes.FETCH_UNREAD_MESSAGE,
      fetchUpdateUserInfo: LoginTypes.FETCH_UPDATE_USERINFO,
      fetchFollowEvent: CommunityTypes.FETCH_FOLLOWERS_EVENT,
      fetchDetail: ActivityTypes.FETCH_DETAIL_ACTIVITY,
      fetchMyMedalsList: CommunityTypes.FETCH_MY_MEDALS,
    }),
    ...Utils,
    // 返回事件
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      }
    },
    // 修改用户信息[头像]
    updateAvatar() {
      this.dependLoginStatus().then(() => {
        if (this.ownerInfo.owner === this.otherInfo.user) {
          this.$refs.uploadPhoto.click();
        }
      });
    },
    // 图片选择之后的处理
    uploadPhoto_change(e) {
      let this_ = this;
      let files = e.target.files;
      let tempInfo = { ...this.otherInfo };

      var reader = new FileReader();
      reader.readAsDataURL(files[0]);
      reader.onload = function() {
        tempInfo["avatar"] = reader.result;
        this_.load_otherInfo(tempInfo);
      };

      UPLOAD_SINGLE_IMAGE(files[0], remoteUrl => {
        let dic = { data: { avatar: remoteUrl } };
        this_.fetchUpdateUserInfo(dic);
      });
    },
    // 关注事件
    followEvent(is_follow) {
      let callback = () => {
        let data = {
          followers: [this.otherInfo.user],
          is_follow: is_follow,
          from: "profile"
        };
        this.fetchFollowEvent(data);
      };
      this.dependLoginStatus().then(callback);
    },
    // 作品/帖子点击事件
    tabClickEvent(type) {
      if (type === "detail") {
        this.jumpToCompany(this.ownerInfo.company.pk);
        return;
      }
      console.log(type);
      this.tab = type;
      this.$router.replace(`/profile/${this.$route.params.user}?tag=${type}`);
    },
    //公司详情页
    jumpToCompany(pk) {
      this.$router.push(`/company/${pk}`);
    },
    // 我的关注列表
    goMyFollower(type) {
      this.dependLoginStatus().then(() => {
        this.$router.push(`/myfollower?type=${type}`);
      });
    }
  },
  created() {},
  watch: {
    currentActivity() {
      this.typeArr = [];
      if (this.currentActivity.is_scratch) {
        this.typeArr.push("scratch3");
      }
      if (this.currentActivity.is_applab) {
        this.typeArr.push("applab");
      }
    }
  },
  mounted() {
    document.documentElement.scrollTop = 0;
    if (this.$route.query.tag) {
      this.tab = this.$route.query.tag;
    } else {
      this.tab = "post";
    }
    if (this.$route.query.number) {
      this.number = this.$route.query.number;
      this.fetchDetail({ pk: this.number });
    }
    let user = this.$route.params.user;
    this.fetchOwnInfo().then(()=>{
      this.fetchMyMedalsList(this.ownerInfo.owner)
    })
    this.fetchOtherInfo(user);
    this.fetchUnreadMessage(user);
  }
};
</script>

<style lang="less" scoped>
.profile {
  background-color: #6b45e1;
  width: 100%;
  min-width: 1100px;
  /* height: 100%; */
  min-height: 100%;
  /* background-position: center; */
  /* background-repeat: no-repeat; */
  background-size: 100%;
  position: relative;
}
.profile__bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
}
.profile__container {
  width: 1000px;
  margin: 0 auto;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  /* height: 100%; */
  /* display: flex;
  flex-direction: column; */
  z-index: 200;
  position: relative;
}
.profile__container__header {
  color: #ff6600;
  /* text-align: center; */
  height: 2.2rem;
  line-height: 2.2rem;
  margin-bottom: 1.5rem;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}
.back {
  height: 2.2rem;
  cursor: pointer;
}
.profile__container__userinfo {
  width: 100%;
  height: 11rem;

  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  border-radius: 0.4rem;
  overflow: hidden;
}
.userinfo__icon1 {
  position: absolute;
  left: 2.5rem;
  top: 0;
  width: 8rem;
}
.userinfo__icon2 {
  position: absolute;
  right: 1.8rem;
  bottom: 0;
  width: 17rem;
}
.userinfo__bg {
  position: relative;
  width: 100%;
  z-index: 105;
  display: inherit;
}
.userinfo__wrapper {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 110;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  justify-content: space-evenly;
}
.userinfo__avatar {
  position: relative;
  display: flex;
  justify-content: center;
  /* margin-top: 10px; */
  cursor: pointer;
  // height: 3.75rem;
  height: 75px;
}
.userinfo__avatar__bg {
  /* height: 80px; */
  height: 100%;
  position: relative;
  z-index: 100;
}
.userinfo__avatar__img {
  // position: absolute;
  // top: 15px;
  // left: calc((100% - 50px) / 2 + 1px);
  // width: 2.5rem;
  // height: 2.5rem;
  // border-radius: 50%;
  // z-index: 99;

  position: absolute;
  top: 15px;
  left: calc((100% - 50px) / 2 + 1px);
  width: 50px;
  height: 50px;
  border-radius: 50%;
  z-index: 99;
}
.userinfo__name {
  // margin-top: 20px;
  // margin-bottom: 20px;
  font-size: 0.75rem;
  color: #333333;
  font-weight: 700;
}
.userinfo_follow {
  background-color: #ff6600;
  color: #ffffff;
  font-size: 0.7rem;
  border-radius: 0.25rem;
  height: 1.5rem;
  line-height: 1.5rem;
  width: 4.5rem;
  text-align: center;
  cursor: pointer;
  &.unselect {
    background: linear-gradient(to bottom, #696e78 0%, #646973 100%);
  }
}
.userinfo__segment {
  /* color: #5F0AFF; */
  /* font-size: 12px; */
  color: #666666;
  font-size: 0.55rem;
  margin-left: 0.15rem;
  font-weight: normal;
}
.userinfo__intro {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size: 0.75rem;
  color: #333333;
  margin-bottom: 0.5rem;
  .follow,
  .fan {
    cursor: pointer;
  }
}
.userinfo__intro__line {
  width: 0.1rem;
  height: 0.5rem;
  background-color: #ff6600;
  /* padding-left: 8px; */
  margin-left: 0.75rem;
  margin-right: 0.75rem;
  display: inline-block;
}
.profile__container__content {
  width: 100%;
  /* height: 600px; */
  flex: 1;
  background-color: #ffffff;
  border-radius: 0.4rem;
  overflow: auto;
  margin-top: 0.5rem;
  /* min-height: calc(100% - 220px - 44px - 30px - 10px); */
  min-height: 30rem;
  display: flex;
  .wrap-left {
    width: 6rem;
    background-color: #f4f3f3;
  }
  .wrap-right {
    width: calc(100% - 7rem);
    position: relative;
  }
}
.contentView__header {
  padding-top: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  .companyBtn {
    position: absolute;
    right: 0.75rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 0.75rem;
    color: #333333;
    cursor: pointer;
    .icon {
      height: 1.5rem;
      margin-right: 0.25rem;
    }
  }
  .row {
    width: 4.5rem;
    height: 2.3rem;
    display: flex;
    margin-left: -10px;
    .circle {
      width: 0.3rem;
      height: 0.3rem;
      background: rgba(119, 78, 229, 1);
      border-radius: 50%;
      flex-direction: column;
      justify-content: center;
      margin-top: 0.7rem;
    }
    .contentView__header__btn {
      width: 4rem;
      font-size: 0.85rem;
      font-family: PingFang SC;
      color: black;
      cursor: pointer;
      text-align: center;
      line-height: 1.5rem;
    }
  }
  .contentView__header__btn.select {
    color: #774ee5;
  }
}

.contentView__header__btn.select {
  color: #774ee5;
}
/*
** 1000， 1.7倍. 760, 1.3倍. 基准 600
*/
@media screen and (max-width: 1006px) {
  .profile__container {
    /* width: 760px; */
  }
  .profile__container__userinfo {
    /* height: 139px; */
  }
}

@media screen and (max-width: 939px) {
  .profile__container {
    /* width: 600px; */
  }
  .profile__container__userinfo {
    /* height: 110px; */
  }
}
</style>
